// Module
var code = "<p>To authorize others, complete the Account Authorizations Agreement. Here&#39;s how:</p> ";
// Exports
export default code;